import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CacheKey } from '../constants/cachekey.constants';
import { CacheService } from '../services/cache.service';
import { SharedConstants } from '../constants/shared.constants';

@Injectable()
export class CanActivateNotFoundGuard implements CanActivate {
    countryCode: string;
    languageCode: string;
    userInfo: any;
    constructor(private _router: Router, private _cacheService: CacheService) {
        this.countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const isLoginRedirect = window.location.href.indexOf('/login') > -1;
        let hasNavPath = this._cacheService.get(CacheKey.Nav_path);
        if (hasNavPath !== undefined && hasNavPath !== null 
            && hasNavPath !== '') {
            if (hasNavPath.includes(SharedConstants.LegacyUrlWhitelistPhrase)) {
                this._cacheService.set(CacheKey.Nav_path, '/');
                hasNavPath = '/';
            }
        }
        if (this.userInfo && isLoginRedirect && !hasNavPath) {
            this._router.navigate(['/', this.countryCode.toLowerCase(), this.languageCode.toLowerCase(), 'home'], { replaceUrl: true });
            return false;
        }
        return true;
    }
}
